<script setup>
import { Handle, Position } from '@vue-flow/core'

const props = defineProps({
    id: String,
    data: Object,
})
</script>

<template>
    <div class="workflow-node workflow-node--action_email">
        <Handle type="target" :position="Position.Top" />
        <div class="workflow-node__type">EMAIL</div>
        <div class="workflow-node__title">
            Send Email
            <span v-if="data?.config?.template_id"> #{{ data.config.template_id }}</span>
        </div>
        <Handle type="source" :position="Position.Bottom" />
    </div>
</template>
